import { Text } from '@fable/components'
import { css, theme, useTheme } from '@fable/theme'
import { Carousel, useCarouselController } from 'components/carousel'

const valueProps = [
  {
    color: theme.colors.fableGreen,
    title: 'Discover social reading',
    description: 'Chat inside the ebook with emojis,  comments and more',
  },
  {
    color: theme.colors.green,
    title: 'Annotate with notes, tabs, and highlights',
    description:
      'Share or keep your notes private with our annotation features',
  },
  {
    color: theme.colors.denim,
    title: 'Support the World Literacy Foundation',
    description:
      'We donate 20% of every book sale to help children learn to read',
  },
]

export const BookDetailValueProps = () => {
  const { colors, breakpoints, motion } = useTheme()
  const controller = useCarouselController()

  return (
    <div>
      <Text tag="h2" type="header" sizing="XS" color={colors.uiGraphite}>
        Why read on Fable?
      </Text>
      <div
        className={css`
          position: relative;
          margin-top: 24px;
        `}
      >
        <Carousel
          controller={controller}
          options={{
            slides: { perView: 'auto', spacing: 11, origin: 0 },
          }}
          childWidths={[
            { width: '70%', breakpoint: 'base' },
            { width: '252px', breakpoint: breakpoints.mobileL },
          ]}
          noOverflow
        >
          {valueProps?.map(({ color, title, description }, i) => (
            <div
              key={i}
              className={css`
                padding: 20px;
                padding-bottom: 24px;
                border-radius: 12px;
                background-color: ${color};
                opacity: ${i < controller.currentSlide ? 0 : 1};
                height: 100%;
                ${motion.transition('opacity')};
              `}
            >
              <Text
                className={css`
                  max-width: 170px;
                  width: 100%;
                `}
                tag="p"
                type="subhead"
                sizing="S"
                color={colors.uiWhite}
              >
                {title}
              </Text>
              <Text
                className={css`
                  margin-top: 8px;
                  line-height: 16px;
                `}
                type="body"
                sizing="S"
                color={colors.uiWhite}
              >
                {description}
              </Text>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  )
}
